import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth0 } from '@auth0/auth0-react';

const PrivateRoute = ({ children }) => {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
    const [checkingAuth, setCheckingAuth] = useState(true);
    const redirectingRef = useRef(false);

    useEffect(() => {
        const checkAuth = async () => {
            if (isLoading) return;

            if (!isAuthenticated) {
                if (redirectingRef.current) return; // already redirecting
                redirectingRef.current = true;

                try {
                    const returnTo = `${window.location.pathname}${window.location.search || ''}`;
                    await loginWithRedirect({ appState: { returnTo } });
                } catch (error) {
                    console.error('Login redirection error', error);
                    redirectingRef.current = false;
                }
            } else {
                setCheckingAuth(false);
            }
        };

        checkAuth();
    }, [isLoading, isAuthenticated, loginWithRedirect]);

    if (isLoading || checkingAuth) {
        return (
            <div className="flex items-center justify-center w-screen h-screen">
                Loading...
            </div>
        );
    }

    return isAuthenticated ? children : null;
};

PrivateRoute.propTypes = {
    children: PropTypes.node.isRequired,
};

export default PrivateRoute;
